import AjaxLoad from '../../lib/ajax-load';
import { initOrReinitFriendlyCaptcha } from '../../lib/friendly-captcha';

class NewsletterRegisterForm {
    constructor ($newsletter, options) {
        this.$newsletter = $newsletter;
        this.$newsletterContent = $newsletter.querySelector('[data-newsletter="content"]');
        this.$newsletterForm = $newsletter.querySelector('form');
        this.widget = null;
    }

    init () {
        if (this.$newsletterForm) {
            this.setEvents();
            this.initFriendlyCaptcha();
        }
    }

    initFriendlyCaptcha () {
        const { widget } = initOrReinitFriendlyCaptcha({
            root: this.$newsletter,
            prevWidget: this.widget,
            label: 'NewsletterRegister'
        });
        this.widget = widget;
    }

    initSelect () {
        const $choices = this.$newsletter.querySelector('[data-choices]');

        if ($choices) {
            import('../../components/form/form-choices.js').then(({ FormChoice }) => {
                let search = $choices.getAttribute('data-choices-search');
                search = search === 'true';

                let sort = $choices.getAttribute('data-choices-sort');
                sort = sort !== 'false';

                const $choice = new FormChoice($choices, {
                    search: search, // eslint-disable-line
                    sort: sort // eslint-disable-line
                });
                $choice.initialize();
            });
        }
    }

    sendTrackingData () {
        window.dataLayer = window.dataLayer || [];
        const request = document.querySelector('[id="newsletter_register_request"]');

        if (request && request.value.indexOf('.') !== -1) {
            window.dataLayer.push({ // eslint-disable-line no-undef
                event: 'Newsletter',
                request: request.options[request.selectedIndex].text
            });
        }
    }

    setEvents () {
        this.$newsletterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.sendForm(this.$newsletterForm.getAttribute('action'));
        });
    }

    sendForm (url) {
        this.$newsletterContent.classList.add('is--loading');

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: 'POST',
            requestData: new FormData(this.$newsletterForm),
            onSuccess: (result) => {
                this.setForm(result, () => {
                    this.$newsletterForm = this.$newsletter.querySelector('form');

                    if (this.$newsletterForm) {
                        this.setEvents();
                        this.initSelect();
                        this.initFriendlyCaptcha();
                    }
                });
            }
        });

        ajaxLoad.initialize();
    }

    setForm (result, callback) {
        const results = JSON.parse(result.toString());

        if (results.success) {
            this.sendTrackingData();
        }

        const template = document.createElement('div');

        if (results.html !== '') {
            template.innerHTML = results.html;
        }

        this.$newsletterContent.innerHTML = template.innerHTML;

        setTimeout(() => {
            this.$newsletterContent.classList.remove('is--loading');

            if (typeof callback === 'function') {
                callback();
            }
        }, 200);
    }
}

export { NewsletterRegisterForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $newsletter = $context.querySelectorAll('[data-newsletter="root"]');

        for (let i = 0; i < $newsletter.length; i++) {
            const $$newsletter = new NewsletterRegisterForm($newsletter[i]);
            $$newsletter.init();
        }
    }
});
